import { useMemo } from 'react';
import { checkToRedirect } from '../../../../utils/checkToRedirect';

export const useReportLinks = ({ jurisdictionId, periodId, groupedWorkflows, project, period }) => {
  const filingType = period?.data?.filing_type;

  return useMemo(() => {
    if (jurisdictionId) {
      const _period = groupedWorkflows?.data?.periods?.find(item => item.id === periodId);
      return [
        { name: 'AFMs', value: '/project' },
        {
          name: groupedWorkflows.data?.name,
          value: checkToRedirect({ ...groupedWorkflows.data, is_workflow_group: true })
        },
        { name: `Year - ${_period?.year}, ${_period?.period}` },
        { name: 'Report' }
      ];
    }

    const projectLink = checkToRedirect(project?.data);
    const baseLinks = [
      { name: 'AIFMs', value: '/project' },
      { name: project?.data?.name, value: projectLink }
    ];

    if (filingType === 'PF_TRANS' || filingType === 'PF_FINAL') {
      return [...baseLinks, { name: 'Report' }];
    }

    if (projectLink?.includes('quaters')) {
      return [
        ...baseLinks,
        {
          name: 'File Upload',
          value: `/project/quaters/${project.data?.id}/${period?.data?.id}/upload-files`
        },
        {
          name: 'Extraction & Transformation',
          value: `/data-extraction/${project.data?.id}/${period?.data?.id}`
        },
        {
          name: 'Output Table',
          value: `/output-tables/${project.data?.id}/${period?.data?.id}`
        },
        { name: 'Report' }
      ];
    }

    return [
      ...baseLinks,
      {
        name: 'Extraction & Transformation',
        value: `/data-extraction/${project?.data?.id}/${period?.data?.id}`
      },
      {
        name: 'Output Table',
        value: `/output-tables/${project?.data?.id}/${period?.data?.id}`
      },
      { name: 'Report' }
    ];
  }, [jurisdictionId, periodId, groupedWorkflows?.data, project?.data, period?.data, filingType]);
};
